<template>
	<div class="layout">
		<div class="support">
			<div class="container">
				<h1 class="title">{{ title }}</h1>
				<div class="links">
					<a v-for="(link, i) in links" :key="i" :href="link.path" class="link" target="_blank">
						<img :src="link.img" class="linkImg" />
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
// Refs/reactives
const title = ref('Welcome to Outfit7 Neo Support.\nWhich game can we help with?');
const links = ref<ImageLinkInterface[]>([
	{
		img: 'https://cdn.outfit7.com/web/talking-tom-and-friends/web/support-ml.png',
		path: 'https://support.mythic-legends.com/hc/en-us'
	}
]);
</script>

<style scoped lang="scss">
@import '@/assets/design';

.support {
	padding: 106px 16px 60px 16px;
	background: linear-gradient(180deg, rgba(35, 35, 35, 0) 0, rgba(35, 35, 35, 0.66) 188px, #151515 417px);

	@media screen and (max-width: 768px) {
		padding-top: 64px;
	}

	@media screen and (max-width: 592px) {
		padding-top: 36px;
	}

	.container {
		width: 100%;
		max-width: 1160px;
		padding: 0;
		margin: 0 auto;
	}

	h1.title {
		position: relative;
		display: block;
		margin-bottom: 108px;
		font-family: 'NotoBold';
		font-size: 48px;
		line-height: 58px;
		color: #fff;
		white-space: pre-line;

		@media screen and (max-width: 768px) {
			margin-bottom: 72px;
			font-size: 28px;
		}

		@media screen and (max-width: 592px) {
			margin-bottom: 44px;
			font-size: 17px;
			line-height: 1.4;
		}
	}

	.links {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		column-gap: 40px;
		row-gap: 40px;

		@media screen and (max-width: 768px) {
			column-gap: 30px;
		}

		@media screen and (max-width: 592px) {
			grid-template-columns: 1fr;
		}

		.link {
			.linkImg {
				width: 100%;
				height: auto;
				border: 0.1px solid rgba(255, 255, 255, 0.2);
				border-radius: 14px;
			}
		}
	}
}
</style>
